import _ from 'lodash'
import { FETCH_CLIENT_CC_DATA_POINT } from '../actions/types'
export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CLIENT_CC_DATA_POINT:
    case 'FETCH_CC_DATA_POINTS':
      return action.payload
    default:
      return state
  }
}
